<template>
  <div class="chapters-container" v-show="chapters.length > 0">
    <div class="chaptersTitle" v-on:click="handleChaptersDisplay">
      <span class="main-title">{{ $t('interactivity.chaptersList') }}</span>
      <div class="chap-arrow-icon"  v-html="!isChapersShow? SVG.DOWN_ARROW_SVG : SVG.UP_ARROW_SVG "> </div>
    </div>
    <div class="ChaptersSection" :class="{
      'chapters-shown': isChapersShow,
      'chapters-hidden': !isChapersShow,
    }">
      <template v-for="(chapter, index) in chapters" :key="index">
        <div class="chapter-row" @click="goToChapter(chapter.timecode)">
          <div class="chapter_info">
            <div class="chapter__index">{{ index + 1 }}.</div>
            <div class="chapter__title">{{ chapter.title }}</div>
          </div>
          <div class="chapter__time">
            {{ getDurationString(chapter.timecode?.toString()) }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import { secondsToDuration } from "../../../../utils/helpers";
import { SVG } from "../../../../../components/utils/const";

import en from '../../../../../i18n/en_US'
import fr from '../../../../../i18n/fr_FR'
export default defineComponent({
  name: "ChaptersSection",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {},
  props: {
    chapters: {
      type: Array,
      required: true,
    },
    information: {
      type: Object,
      required: true,
    },
    player: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isChapersShow: true,
      SVG:SVG
    };
  },
  methods: {
    handleChaptersDisplay() {
      this.isChapersShow = !this.isChapersShow;
    },
    getDurationString(s) {
      return secondsToDuration(s);
    },
    goToChapter(time) {
      this.player.currentTime(time);
    },
  },
});
</script>

<style>
.main-title {
  font-weight: 600;
}

.chaptersTitle {
  display: flex;
  align-items: center;
}

.chap-arrow-icon {
  width: auto;
  margin-left: 0.33em;
  cursor: pointer;
}
.chap-arrow-icon svg{
  width: 1.5em;
  height: 1.5em;
  display: block;
}
.ChaptersSection {
  margin: 0;
}

.ChaptersSection.chapters-hidden {
  display: none;
}

.chapter-row {
  display: flex;
  width: 100%;
  padding: 0.5em;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.chapter-row:hover {
  font-weight: 600;
}

.chapter-row:not(:last-child) {
  border-bottom: 1px solid var(--vm-color-three-04);
}

.chapter-row .chapter_info {
  display: flex;
}

.chapter__index {
  color: var(--vm-color-two) !important;
  font-weight: 600;
  margin-right: 0.2em;
}

.chapter__time {
  font-size: 0.8em;
  font-weight: 600;
  letter-spacing: 0.1em;
}

.chapters-hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  margin: 0 !important;
}

.chapters-shown {
  opacity: 1;
  height: auto;
  transition: visibility 0s, opacity 0.5s linear;
}
</style>
